interface TaxInfo {
  type: string;
  name: string;
  example: string;
  states: string[];
}

const stripeTaxIdTypes: Record<string, TaxInfo[]> = {
  "AL" /* Albania */: [
    {
      type: "al_tin",
      name: "Albania Tax Identification Number",
      example: "J12345678N",
      states: []
    }
  ],
  "AD" /* Andorra */: [
    {
      type: "ad_nrt",
      name: "Andorran NRT number",
      example: "A-123456-Z",
      states: []
    }
  ],
  "AO" /* Angola */: [
    {
      type: "ao_tin",
      name: "Angola Tax Identification Number",
      example: "5123456789",
      states: []
    }
  ],
  "AR" /* Argentina */: [
    {
      type: "ar_cuit",
      name: "Argentinian tax ID number",
      example: "12-3456789-01",
      states: []
    }
  ],
  "AM" /* Armenia */: [
    {
      type: "am_tin",
      name: "Armenia Tax Identification Number",
      example: "02538904",
      states: []
    }
  ],
  "AW" /* Aruba */: [
    {
      type: "aw_tin",
      name: "Aruba Tax Identification Number",
      example: "12345678",
      states: []
    }
  ],
  "AU" /* Australia */: [
    {
      type: "au_abn",
      name: "Australian Business Number (AU ABN)",
      example: "12345678912",
      states: []
    },
    {
      type: "au_arn",
      name: "Australian Taxation Office Reference Number",
      example: "123456789123",
      states: []
    }
  ],
  "AT" /* Austria */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "ATU12345678",
      states: []
    }
  ],
  "AZ" /* Azerbaijan */: [
    {
      type: "az_tin",
      name: "Azerbaijan Tax Identification Number",
      example: "0123456789",
      states: []
    }
  ],
  "BS" /* Bahamas */: [
    {
      type: "bs_tin",
      name: "Bahamas Tax Identification Number",
      example: "123.456.789",
      states: []
    }
  ],
  "BH" /* Bahrain */: [
    {
      type: "bh_vat",
      name: "Bahraini VAT Number",
      example: "123456789012345",
      states: []
    }
  ],
  "BD" /* Bangladesh */: [
    {
      type: "bd_bin",
      name: "Bangladesh Business Identification Number",
      example: "123456789-0123",
      states: []
    }
  ],
  "BB" /* Barbados */: [
    {
      type: "bb_tin",
      name: "Barbados Tax Identification Number",
      example: "1123456789012",
      states: []
    }
  ],
  "BY" /* Belarus */: [
    {
      type: "by_tin",
      name: "Belarus TIN Number",
      example: "123456789",
      states: []
    }
  ],
  "BE" /* Belgium */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "BE0123456789",
      states: []
    }
  ],
  "BJ" /* Benin */: [
    {
      type: "bj_ifu",
      name: "Benin Tax Identification Number (Identifiant Fiscal Unique)",
      example: "1234567890123",
      states: []
    }
  ],
  "BO" /* Bolivia */: [
    {
      type: "bo_tin",
      name: "Bolivian tax ID",
      example: "123456789",
      states: []
    }
  ],
  "BA" /* Bosnia & Herzegovina */: [
    {
      type: "ba_tin",
      name: "Bosnia and Herzegovina Tax Identification Number",
      example: "123456789012",
      states: []
    }
  ],
  "BR" /* Brazil */: [
    {
      type: "br_cnpj",
      name: "Brazilian CNPJ number",
      example: "01.234.456/5432-10",
      states: []
    },
    {
      type: "br_cpf",
      name: "Brazilian CPF number",
      example: "123.456.789-87",
      states: []
    }
  ],
  "BG" /* Bulgaria */: [
    // {
    //   type: "bg_uic",
    //   name: "Bulgaria Unified Identification Code",
    //   example: "123456789",
    //   states: []
    // },
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "BG0123456789",
      states: []
    }
  ],
  "BF" /* Burkina Faso */: [
    {
      type: "bf_ifu",
      name: "Burkina Faso Tax Identification Number (Numéro d'Identifiant Fiscal Unique)",
      example: "12345678A",
      states: []
    }
  ],
  "KH" /* Cambodia */: [
    {
      type: "kh_tin",
      name: "Cambodia Tax Identification Number",
      example: "1001-123456789",
      states: []
    }
  ],
  "CM" /* Cameroon */: [
    {
      type: "cm_niu",
      name: "Cameroon Tax Identification Number (Numéro d'Identifiant fiscal Unique)",
      example: "M123456789000L",
      states: []
    }
  ],
  "CA" /* Canada */: [
    {
      type: "ca_bn",
      name: "Canadian BN",
      example: "123456789",
      states: [
        "CA-AB", "CA-BC", "CA-MB", "CA-NB", "CA-NL",
        "CA-NS", "CA-ON", "CA-PE", "CA-QC", "CA-SK",
        "CA-NT", "CA-NU", "CA-YT"
      ]
    },
    {
      type: "ca_gst_hst",
      name: "Canadian GST/HST number",
      example: "123456789RT0002",
      states: [
        "CA-AB", "CA-ON", "CA-NB", "CA-NS", "CA-PE",
        "CA-NL", "CA-NT", "CA-NU", "CA-YT"
      ]
    },
    {
      type: "ca_pst_bc",
      name: "Canadian PST number (British Columbia)",
      example: "PST-1234-5678",
      states: ["CA-BC"]
    },
    {
      type: "ca_pst_mb",
      name: "Canadian PST number (Manitoba)",
      example: "123456-7",
      states: ["CA-MB"]
    },
    {
      type: "ca_pst_sk",
      name: "Canadian PST number (Saskatchewan)",
      example: "1234567",
      states: ["CA-SK"]
    },
    {
      type: "ca_qst",
      name: "Canadian QST number (Québec)",
      example: "1234567890TQ1234",
      states: ["CA-QC"]
    }
  ],
  "CV" /* Cape Verde */: [
    {
      type: "cv_nif",
      name: "Cape Verde Tax Identification Number (Número de Identificação Fiscal)",
      example: "213456789",
      states: []
    }
  ],
  "CL" /* Chile */: [
    {
      type: "cl_tin",
      name: "Chilean TIN",
      example: "12.345.678-K",
      states: []
    }
  ],
  "CN" /* China */: [
    {
      type: "cn_tin",
      name: "Chinese tax ID",
      example: "123456789012345678",
      states: []
    }
  ],
  "CO" /* Colombia */: [
    {
      type: "co_nit",
      name: "Colombian NIT number",
      example: "123.456.789-0",
      states: []
    }
  ],
  "CD" /* Congo - Kinshasa (DRC) */: [
    {
      type: "cd_nif",
      name: "Congo (DR) Tax Identification Number (Número de Identificação Fiscal)",
      example: "A0123456M",
      states: []
    }
  ],
  "CR" /* Costa Rica */: [
    {
      type: "cr_tin",
      name: "Costa Rican tax ID",
      example: "1-234-567890",
      states: []
    }
  ],
  "HR" /* Croatia */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "HR12345678912",
      states: []
    },
    // {
    //   type: "hr_oib",
    //   name: "Croatian Personal Identification Number",
    //   example: "12345678901",
    //   states: []
    // }
  ],
  "CY" /* Cyprus */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "CY12345678Z",
      states: []
    }
  ],
  "CZ" /* Czech Republic */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "CZ1234567890",
      states: []
    }
  ],
  "DK" /* Denmark */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "DK12345678",
      states: []
    }
  ],
  "DO" /* Dominican Republic */: [
    {
      type: "do_rcn",
      name: "Dominican RCN number",
      example: "123-4567890-1",
      states: []
    }
  ],
  "EC" /* Ecuador */: [
    {
      type: "ec_ruc",
      name: "Ecuadorian RUC number",
      example: "1234567890001",
      states: []
    }
  ],
  "EG" /* Egypt */: [
    {
      type: "eg_tin",
      name: "Egyptian Tax Identification Number",
      example: "123456789",
      states: []
    }
  ],
  "SV" /* El Salvador */: [
    {
      type: "sv_nit",
      name: "El Salvadorian NIT number",
      example: "1234-567890-123-4",
      states: []
    }
  ],
  "EE" /* Estonia */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "EE123456789",
      states: []
    }
  ],
  "ET" /* Ethiopia */: [
    {
      type: "et_tin",
      name: "Ethiopia Tax Identification Number",
      example: "1234567890",
      states: []
    }
  ],
  "EU" /* EU (для One Stop Shop) */: [
    {
      type: "eu_oss_vat",
      name: "European One Stop Shop VAT number for non-Union scheme",
      example: "EU123456789",
      states: []
    }
  ],
  "FI" /* Finland */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "FI12345678",
      states: []
    }
  ],
  "FR" /* France */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "FRAB123456789",
      states: []
    }
  ],
  "GE" /* Georgia */: [
    {
      type: "ge_vat",
      name: "Georgian VAT",
      example: "123456789",
      states: []
    }
  ],
  "DE" /* Germany */: [
    // {
    //   type: "de_stn",
    //   name: "German Tax Number (Steuernummer)",
    //   example: "1234567890",
    //   states: []
    // },
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "DE123456789",
      states: []
    }
  ],
  "GR" /* Greece */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "EL123456789",
      states: []
    }
  ],
  "GN" /* Guinea */: [
    {
      type: "gn_nif",
      name: "Guinea Tax Identification Number (Número de Identificação Fiscal)",
      example: "123456789",
      states: []
    }
  ],
  "HK" /* Hong Kong */: [
    {
      type: "hk_br",
      name: "Hong Kong BR number",
      example: "12345678",
      states: []
    }
  ],
  "HU" /* Hungary */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "HU12345678",
      states: []
    },
    // {
    //   type: "hu_tin",
    //   name: "Hungary tax number (adószám)",
    //   example: "12345678-1-23",
    //   states: []
    // }
  ],
  "IS" /* Iceland */: [
    {
      type: "is_vat",
      name: "Icelandic VAT",
      example: "123456",
      states: []
    }
  ],
  "IN" /* India */: [
    {
      type: "in_gst",
      name: "Indian GST number",
      example: "12ABCDE3456FGZH",
      states: []
    }
  ],
  "ID" /* Indonesia */: [
    {
      type: "id_npwp",
      name: "Indonesian NPWP number",
      example: "012.345.678.9-012.345",
      states: []
    }
  ],
  "IE" /* Ireland */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "IE1234567AB",
      states: []
    }
  ],
  "IL" /* Israel */: [
    {
      type: "il_vat",
      name: "Israel VAT",
      example: "000012345",
      states: []
    }
  ],
  "IT" /* Italy */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "IT12345678912",
      states: []
    }
  ],
  "JP" /* Japan */: [
    {
      type: "jp_trn",
      name: "Japanese Tax Registration Number (*Tōroku Bangō*)",
      example: "T1234567891234",
      states: []
    },
    {
      type: "jp_cn",
      name: "Japanese Corporate Number (*Hōjin Bangō*)",
      example: "1234567891234",
      states: []
    },
    {
      type: "jp_rn",
      name:
        "Japanese Registered Foreign Businesses' Registration Number (*Tōroku Kokugai Jigyōsha no Tōroku Bangō*)",
      example: "12345",
      states: []
    }
  ],
  "KZ" /* Kazakhstan */: [
    {
      type: "kz_bin",
      name: "Kazakhstani Business Identification Number",
      example: "123456789012",
      states: []
    }
  ],
  "KE" /* Kenya */: [
    {
      type: "ke_pin",
      name: "Kenya Revenue Authority Personal Identification Number",
      example: "P000111111A",
      states: []
    }
  ],
  "KG" /* Kyrgyzstan */: [
    {
      type: "kg_tin",
      name: "Kyrgyzstan Tax Identification Number",
      example: "12345678901234",
      states: []
    }
  ],
  "LA" /* Laos */: [
    {
      type: "la_tin",
      name: "Laos Tax Identification Number",
      example: "123456789-000",
      states: []
    }
  ],
  "LV" /* Latvia */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "LV12345678912",
      states: []
    }
  ],
  "LI" /* Liechtenstein */: [
    // {
    //   type: "li_uid",
    //   name: "Liechtensteinian UID number",
    //   example: "CHE123456789",
    //   states: []
    // },
    {
      type: "li_vat",
      name: "Liechtensteinian VAT number",
      example: "12345",
      states: []
    }
  ],
  "LT" /* Lithuania */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "LT123456789123",
      states: []
    }
  ],
  "LU" /* Luxembourg */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "LU12345678",
      states: []
    }
  ],
  "MY" /* Malaysia */: [
    {
      type: "my_frp",
      name: "Malaysian FRP number",
      example: "12345678",
      states: []
    },
    {
      type: "my_itn",
      name: "Malaysian ITN",
      example: "C 1234567890",
      states: []
    },
    {
      type: "my_sst",
      name: "Malaysian SST number",
      example: "A12-3456-78912345",
      states: []
    }
  ],
  "MT" /* Malta */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "MT12345678",
      states: []
    }
  ],
  "MR" /* Mauritania */: [
    {
      type: "mr_nif",
      name: "Mauritania Tax Identification Number (Número de Identificação Fiscal)",
      example: "12345678",
      states: []
    }
  ],
  "MX" /* Mexico */: [
    {
      type: "mx_rfc",
      name: "Mexican RFC number",
      example: "ABC010203AB9",
      states: []
    }
  ],
  "MD" /* Moldova */: [
    {
      type: "md_vat",
      name: "Moldova VAT Number",
      example: "1234567",
      states: []
    }
  ],
  "ME" /* Montenegro */: [
    {
      type: "me_pib",
      name: "Montenegro PIB Number",
      example: "12345678",
      states: []
    }
  ],
  "MA" /* Morocco */: [
    {
      type: "ma_vat",
      name: "Morocco VAT Number",
      example: "12345678",
      states: []
    }
  ],
  "NP" /* Nepal */: [
    {
      type: "np_pan",
      name: "Nepal PAN Number",
      example: "123456789",
      states: []
    }
  ],
  "NL" /* Netherlands */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "NL123456789B12",
      states: []
    }
  ],
  "NZ" /* New Zealand */: [
    {
      type: "nz_gst",
      name: "New Zealand GST number",
      example: "123456789",
      states: []
    }
  ],
  "NG" /* Nigeria */: [
    {
      type: "ng_tin",
      name: "Nigerian Tax Identification Number",
      example: "12345678-0001",
      states: []
    }
  ],
  "MK" /* North Macedonia */: [
    {
      type: "mk_vat",
      name: "North Macedonia VAT Number",
      example: "MK1234567890123",
      states: []
    }
  ],
  "NO" /* Norway */: [
    {
      type: "no_vat",
      name: "Norwegian VAT number",
      example: "123456789MVA",
      states: []
    }
  ],
  "OM" /* Oman */: [
    {
      type: "om_vat",
      name: "Omani VAT Number",
      example: "OM1234567890",
      states: []
    }
  ],
  "PE" /* Peru */: [
    {
      type: "pe_ruc",
      name: "Peruvian RUC number",
      example: "12345678901",
      states: []
    }
  ],
  "PH" /* Philippines */: [
    {
      type: "ph_tin",
      name: "Philippines Tax Identification Number",
      example: "123456789012",
      states: []
    }
  ],
  "PL" /* Poland */: [
    {
      type: "eu_vat",
      name: "European VAT Number",
      example: "PL1234567890",
      states: []
    }
  ],
  "PT" /* Portugal */: [
    {
      type: "eu_vat",
      name: "European VAT Number",
      example: "PT123456789",
      states: []
    }
  ],
  "RO" /* Romania */: [
    {
      type: "eu_vat",
      name: "European VAT Number",
      example: "RO123456789",
      states: []
    },
    // {
    //   type: "ro_tin",
    //   name: "Romanian tax ID number",
    //   example: "1234567890123",
    //   states: []
    // }
  ],
  "RU" /* Russia */: [
    {
      type: "ru_inn",
      name: "Russian INN",
      example: "1234567891",
      states: []
    },
    {
      type: "ru_kpp",
      name: "Russian KPP",
      example: "123456789",
      states: []
    }
  ],
  "SA" /* Saudi Arabia */: [
    {
      type: "sa_vat",
      name: "Saudi Arabia VAT",
      example: "123456789012345",
      states: []
    }
  ],
  "SN" /* Senegal */: [
    {
      type: "sn_ninea",
      name: "Senegal NINEA Number",
      example: "12345672A2",
      states: []
    }
  ],
  "RS" /* Serbia */: [
    {
      type: "rs_pib",
      name: "Serbian PIB number",
      example: "123456789",
      states: []
    }
  ],
  "SG" /* Singapore */: [
    {
      type: "sg_gst",
      name: "Singaporean GST",
      example: "M12345678X",
      states: []
    },
    {
      type: "sg_uen",
      name: "Singaporean UEN",
      example: "123456789F",
      states: []
    }
  ],
  "SK" /* Slovakia */: [
    {
      type: "eu_vat",
      name: "European VAT Number",
      example: "SK1234567891",
      states: []
    }
  ],
  "SI" /* Slovenia */: [
    {
      type: "eu_vat",
      name: "European VAT Number",
      example: "SI12345678",
      states: []
    }
  ],
  "ZA" /* South Africa */: [
    {
      type: "za_vat",
      name: "South African VAT number",
      example: "4123456789",
      states: []
    }
  ],
  "KR" /* South Korea */: [
    {
      type: "kr_brn",
      name: "Korean BRN",
      example: "123-45-67890",
      states: []
    }
  ],
  "ES" /* Spain */: [
    // {
    //   type: "es_cif",
    //   name: "Spanish NIF number (previously Spanish CIF number)",
    //   example: "A12345678",
    //   states: []
    // },
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "ESA1234567Z",
      states: []
    }
  ],
  "SR" /* Suriname */: [
    {
      type: "sr_fin",
      name: "Suriname FIN Number",
      example: "1234567890",
      states: []
    }
  ],
  "SE" /* Sweden */: [
    {
      type: "eu_vat",
      name: "European VAT number",
      example: "SE123456789012",
      states: []
    }
  ],
  "CH" /* Switzerland */: [
    // {
    //   type: "ch_uid",
    //   name: "Switzerland UID number",
    //   example: "CHE-123.456.789 HR",
    //   states: []
    // },
    {
      type: "ch_vat",
      name: "Switzerland VAT number",
      example: "CHE-123.456.789 MWST",
      states: []
    }
  ],
  "TW" /* Taiwan */: [
    {
      type: "tw_vat",
      name: "Taiwanese VAT",
      example: "12345678",
      states: []
    }
  ],
  "TJ" /* Tajikistan */: [
    {
      type: "tj_tin",
      name: "Tajikistan Tax Identification Number",
      example: "123456789",
      states: []
    }
  ],
  "TZ" /* Tanzania */: [
    {
      type: "tz_vat",
      name: "Tanzania VAT Number",
      example: "TZ123456789",
      states: []
    }
  ],
  "TH" /* Thailand */: [
    {
      type: "th_vat",
      name: "Thai VAT",
      example: "1234567891234",
      states: []
    }
  ],
  "TR" /* Turkey */: [
    {
      type: "tr_tin",
      name: "Turkish Tax Identification Number",
      example: "0123456789",
      states: []
    }
  ],
  "UG" /* Uganda */: [
    {
      type: "ug_tin",
      name: "Uganda Tax Identification Number",
      example: "1014751879",
      states: []
    }
  ],
  "UA" /* Ukraine */: [
    {
      type: "ua_vat",
      name: "Ukrainian VAT",
      example: "123456789",
      states: []
    }
  ],
  "AE" /* United Arab Emirates */: [
    {
      type: "ae_trn",
      name: "United Arab Emirates TRN",
      example: "123456789012345",
      states: []
    }
  ],
  "GB" /* United Kingdom */: [
    {
      type: "eu_vat",
      name: "Northern Ireland VAT number",
      example: "XI123456789",
      states: []
    },
    // {
    //   type: "gb_vat",
    //   name: "United Kingdom VAT number",
    //   example: "GB123456789",
    //   states: []
    // }
  ],
  "US" /* United States */: [
    {
      type: "us_ein",
      name: "United States EIN",
      example: "12-3456789",
      states: [
        "US-AL", "US-AK", "US-AZ", "US-AR", "US-CA", "US-CO", "US-CT", "US-DE", "US-FL", "US-GA",
        "US-HI", "US-ID", "US-IL", "US-IN", "US-IA", "US-KS", "US-KY", "US-LA", "US-ME", "US-MD",
        "US-MA", "US-MI", "US-MN", "US-MS", "US-MO", "US-MT", "US-NE", "US-NV", "US-NH", "US-NJ",
        "US-NM", "US-NY", "US-NC", "US-ND", "US-OH", "US-OK", "US-OR", "US-PA", "US-RI", "US-SC",
        "US-SD", "US-TN", "US-TX", "US-UT", "US-VT", "US-VA", "US-WA", "US-WV", "US-WI", "US-WY"
      ]
    }
  ],
  "UY" /* Uruguay */: [
    {
      type: "uy_ruc",
      name: "Uruguayan RUC number",
      example: "123456789012",
      states: []
    }
  ],
  "UZ" /* Uzbekistan */: [
    {
      type: "uz_vat",
      name: "Uzbekistan VAT Number",
      example: "123456789012",
      states: []
    },
    {
      type: "uz_tin",
      name: "Uzbekistan TIN Number",
      example: "123456789",
      states: []
    }
  ],
  "VE" /* Venezuela */: [
    {
      type: "ve_rif",
      name: "Venezuelan RIF number",
      example: "A-12345678-9",
      states: []
    }
  ],
  "VN" /* Vietnam */: [
    {
      type: "vn_tin",
      name: "Vietnamese tax ID number",
      example: "1234567890",
      states: []
    }
  ],
  "ZM" /* Zambia */: [
    {
      type: "zm_tin",
      name: "Zambia Tax Identification Number",
      example: "1004751879",
      states: []
    }
  ],
  "ZW" /* Zimbabwe */: [
    {
      type: "zw_tin",
      name: "Zimbabwe Tax Identification Number",
      example: "1234567890",
      states: []
    }
  ]
};

export function getStripeTaxIdTypesByCountry(countryCode: string, stateCode?: string): TaxInfo[] {
  const upperCountryCode: string = countryCode.toUpperCase();
  let countryTaxTypes: TaxInfo[] | undefined = stripeTaxIdTypes[upperCountryCode];

  if (!countryTaxTypes) {
    return [];
  }

  if (stateCode) {
    countryTaxTypes = countryTaxTypes.filter(t => t.states.includes(stateCode))
  }

  return countryTaxTypes;
}
